/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';
import { selectCommonState } from '../selectors';

export const selectSidebarState = createSelector(
  selectCommonState,
  (uiState) => uiState.sidebar
);

export const selectGlobalLoaderState = createSelector(
  selectCommonState,
  (uiState) => uiState.globalLoader
);
